<template>
  <nav class="NavBar d-flex flex-row">
    <div class="NavBar__logo">
      <router-link :to="{ name: 'Home' }">
        <Logo :organisation="getCurrentTheme.details.organization" :image="getCurrentTheme.details.logo" />
      </router-link>
    </div>
    <!-- <p class="NavBar__description align-self-center my-0 flex-grow-1">
      <span class="ml-2 d-flex">
        {{ pageTitle }}
      </span>
    </p> -->
    <div class="d-flex flex-row justify-content-end flex-grow-1 align-self-center align-items-center">
      <slot />

      <span class="NavBar__Management d-inline-flex align-center mr-3"
        :class="{ 'NavBar__Management--visible': managementDashboardActive }" :value="managementDashboardActive"
        @click="showActiveItem('managementDashboardActive')">
        <i class="far fa-fw fa-info-circle icon" />
      </span>

      <span v-if="getShowLocationCriteria" class="NavBar__Management d-inline-flex align-center mr-3"
        :class="{ 'NavBar__Management--visible': locationCriteriaActive }" :value="locationCriteriaActive"
        @click="showActiveItem('locationCriteriaActive')">
        <i class="far fa-fw fa-rectangle-list icon" />
      </span>

      <span class="NavBar__Profile d-inline-flex align-center mr-3"
        :class="{ 'NavBar__Profile--visible': profileActive }" :value="profileActive"
        @click="showActiveItem('profileActive')">
        <i class="far fa-fw fa-user icon" />
      </span>

      <span class="NavBar__ValidationNotification d-inline-flex align-center mr-3"
        :class="{ 'NavBar__ValidationNotification--visible': validationAlertsActive }" :value="validationAlertsActive"
        @click="showActiveItem('validationAlertsActive')">
        <i class="far fa-fw fa-bell icon" />
      </span>

      <button type="button" aria-label="Apps" class="NavBar__Apps d-inline-flex align-center mr-3"
        :class="{ 'NavBar__Apps--visible': appsActive }" :value="appsActive"
        @click="showActiveItem('appsActive')">
        <i class="far fa-fw fa-grid-2 icon" />
      </button>

      <span class="NavBar__Logout d-inline-flex align-center mr-3" :class="{ 'NavBar__Menu--visible': menuActive }"
        :value="menuActive" @click="showActiveItem('menuActive')">
        <i class="far fa-fw fa-bars icon" />
      </span>
    </div>
    <NavBarApps v-if="appsActive" :style="{ right: profileCardOffset }" />
    <ProfileCard v-if="profileActive" :style="{ right: profileCardOffset }" />
    <NavBarMenu v-if="menuActive" :style="{ right: profileCardOffset }" />
    <ValidationNotification v-if="validationAlertsActive" :style="{ right: profileCardOffset }" />
    <ManagementDashboard v-if="managementDashboardActive" :style="{ right: profileCardOffset }" />

    <LocationCriteria v-if="locationCriteriaActive" :style="{ right: profileCardOffset }" />
  </nav>
</template>

<script>
import Logo from '@/components/navbar/Logo'

import ManagementDashboard from '@/components/navbar/ManagementDashboard'
import LocationCriteria from '@/components/navbar/LocationCriteria'
import ValidationNotification from '@/components/navbar/ValidationNotification'
import ProfileCard from '@/components/profile/ProfileCard'
import NavBarMenu from '@/components/common/NavBarMenu'
import NavBarApps from '@/components/navbar/NavBarApps'

import { mapGetters, mapState } from 'vuex'
import { EventBus } from '@/services/eventbus'

export default {
  name: 'NavBar',
  components: {
    Logo, ProfileCard, NavBarMenu, NavBarApps, ValidationNotification, ManagementDashboard, LocationCriteria,
  },
  data() {
    return {
      profileActive: false,
      menuActive: false,
      appsActive: false,
      validationAlertsActive: false,
      managementDashboardActive: false,
      locationCriteriaActive: false,
    }
  },
  computed: {
    ...mapState(['pageTitle']),
    ...mapGetters('config', ['getCurrentTheme', 'getShowLocationCriteria']),
    /**
     * We need to avoid the profile card covering up the scrollbar of the main page content
     */
    profileCardOffset() {
      return '1.25em'
    },
    organization() {
      return this.getCurrentTheme.details.organization
    },
  },
  mounted() {
    EventBus.$on('overlay-hide', this.hideActiveItems)
  },
  beforeDestroy() {
    EventBus.$off('overlay-hide', this.hideActiveItems)
  },
  methods: {
    hideActiveItems() {
      this.profileActive = this.menuActive = this.appsActive = this.validationAlertsActive = this.managementDashboardActive = this.locationCriteriaActive = false
    },
    showActiveItem(item) {
      this[item] = true
      EventBus.$emit('overlay-show')
    },
  },
}
</script>

<style lang="scss">
.NavBar {
  position: relative;
  height: 80px;
  min-height: 80px;
  background: var(--primary);
  box-shadow: 0px -1px 0px 0px rgba(223, 226, 229, 1) inset;
  user-select: none;

  &__logo {
    display: flex;
    align-items: center;
    height: 80px;

  }

  &__description {
    height: 1.1rem;
    font-size: 1.1rem;
    color: var(--grey);

    @media (max-width: 1200px) {
      span {
        display: none;
      }
    }

    @media (max-width: 920px) {
      display: none;
    }
  }

  .form-group {
    margin-bottom: 0
  }

  a:hover {
    text-decoration: none
  }

  .icon {
    color: white;
    font-size: 1.75rem;
    cursor: pointer;
  }

  // Strip the UA button chrome so this control matches the sibling spans
  &__Apps {
    background: none;
    border: 0;
    padding: 0;

    &:focus-visible {
      outline: 2px solid white;
      outline-offset: 2px;
    }
  }

  .ProfileCard,
  .NavBarMenu,
  .NavBarApps,
  .ManagementDashboard,
  .ValidationNotification {
    position: absolute;
    top: 68px;
    box-sizing: 0px 1px 3px 0px #dfe2e5;
  }
}
</style>
